<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

<!--      <a-form-model-item prop="useOrderId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.优惠券使用订单id')}}<template slot="title">{{$t('优惠券自动发放-用户.优惠券使用订单id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.useOrderId"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.优惠券使用订单id')" />
      </a-form-model-item>
      <a-form-model-item prop="useItemId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.优惠券使用商品子订单id')}}<template slot="title">{{$t('优惠券自动发放-用户.优惠券使用商品子订单id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.useItemId"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.优惠券使用商品子订单id')" />
      </a-form-model-item>-->
      <a-form-model-item prop="money" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.面额')}}<template slot="title">{{$t('优惠券自动发放-用户.面额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.money"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.面额')" />
      </a-form-model-item>
<!--      <a-form-model-item prop="unit" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.一个单位发放面额')}}<template slot="title">{{$t('优惠券自动发放-用户.一个单位发放面额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.unit"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.一个单位发放面额')" />
      </a-form-model-item>
      <a-form-model-item prop="count" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.单位数量')}}<template slot="title">{{$t('优惠券自动发放-用户.单位数量')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.count"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.单位数量')" />
      </a-form-model-item>-->
<!--      <a-form-model-item prop="detailMessage" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.优惠券详细信息')}}<template slot="title">{{$t('优惠券自动发放-用户.优惠券详细信息')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.detailMessage" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.优惠券详细信息')" />
      </a-form-model-item>
      <a-form-model-item prop="usstate" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')}}<template slot="title">{{$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.usstate"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')" />
      </a-form-model-item>-->
      <a-form-model-item :label="$t('优惠券自动发放-用户.有效期开始时间')" prop="startTime">
        <a-date-picker v-model="form.startTime" valueFormat='YYYY-MM-DD'
                       :placeholder="$t('优惠券自动发放-用户.有效期开始时间')"/>
      </a-form-model-item>
<!--      <a-form-model-item prop="endTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.有效期结束时间')}}<template slot="title">{{$t('优惠券自动发放-用户.有效期结束时间')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>-->
<!--      <a-form-model-item prop="useTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.使用时间')}}<template slot="title">{{$t('优惠券自动发放-用户.使用时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.useTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.备注')}}<template slot="title">{{$t('优惠券自动发放-用户.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>-->
      <a-form-model-item :label="$t('优惠券自动发放-用户.优惠券状态 1正常；2作废')" prop="state">
        <a-radio-group v-model="form.state">
          <a-radio v-for="(item, index) in this.customDict.CouponAutoEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>

<!--      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.领用人')}}<template slot="title">{{$t('优惠券自动发放-用户.领用人')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.领用人')" />
      </a-form-model-item>-->

      <a-form-model-item :label="$t('优惠券自动发放-用户.领用人')" prop="userId" >
        <a-button type="dashed" @click="openUserSelect" danger>
          <span style="color: dodgerblue"> {{$t('优惠券自动发放-用户.领用人')}}</span>
        </a-button>
      </a-form-model-item>

      <!--      <a-form-model-item prop="shopId" >
              <span slot="label" >
                <a-tooltip>
                  {{$t('优惠券自动发放-用户.店铺ID')}}<template slot="title">{{$t('优惠券自动发放-用户.店铺ID')}}</template>
                </a-tooltip>
              </span>
              <a-input v-model="form.shopId"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.店铺ID')" />
            </a-form-model-item>-->

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>

      <!--  领用人    -->
      <a-table
               :loading="userLoading"
               rowKey="id"
               :size="tableSize"
               :columns="userColumns"
               :data-source="form.userList"
               :pagination="false"
               :bordered="tableBordered">
        <span slot="activityType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.ActivityTypeEnum" :value="record.activityType"/>
        </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.ActivitySaleStatusEnum" :value="record.status"/>
        </span>
        <template slot="coverPic" slot-scope="text, record">
          <div>
            <img v-if="record.coverPic" :src="record.coverPic"  style="width:60px;height:62px;" @click="handleRecordPreview(record.coverPic)" alt="none"/>
          </div>
        </template>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none"/>
          </div>
        </template>
        <template slot="posterPic" slot-scope="text, record">
          <div>
            <img v-if="record.posterPic" :src="record.posterPic"  style="width:60px;height:62px;" @click="handleRecordPreview(record.posterPic)" alt="none"/>
          </div>
        </template>
      </a-table>

      <a-form-model-item :label="$t('通用.文本.选择商品')" prop="businessId" >
        <a-button type="dashed" @click="openProdSelect" danger>
          <span style="color: dodgerblue"> {{$t('通用.文本.选择商品')}}</span>
        </a-button>
      </a-form-model-item>
<!--      <a-form-model-item prop="goodId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('优惠券自动发放-用户.商品id')}}<template slot="title">{{$t('优惠券自动发放-用户.商品id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodId"  :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.商品id')" />
      </a-form-model-item>-->
      <!-- 数据展示 -->
      <a-table
               :loading="goodsLoading"
               :scroll="{ x: '160%' }"
               rowKey="id"
               :size="tableSize"
               :columns="goodsColumns"
               :data-source="form.goodsList"
               :pagination="false"
               :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>

        <span slot="categoryId" slot-scope="text, record">
            {{getCategoryNameById(record.categoryId)}}
        </span>
        <span slot="brandId" slot-scope="text, record">
             {{getBrandNameById(record.brandId)}}
          </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
          </span>
      </a-table>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <checkbox-user-select-form ref="checkboxUserSelectForm" @userSelect="indexUserSelect"></checkbox-user-select-form>
    <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>
  </a-drawer>
</template>

<script>
import { getCouponAuto, addCouponAuto, updateCouponAuto } from '@/api/coupon/couponAuto'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import checkboxUserSelectForm from "@/views/advert/banner/modules/CheckboxSelectForm";
import RadioGoodsSelectForm from "@/views/goods/goods/modules/RadioSelectForm";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,checkboxUserSelectForm,RadioGoodsSelectForm,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      userLoading: false,
      goodsLoading: false,
      userColumns: [
        {
          title: "手机号",
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: "昵称",
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: "头像",
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },
        {
          title:"注册时间",
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
      ],
      goodsColumns: [
        {
          title: this.$t('商品.商品编号'),
          dataIndex: 'id',
          width: 100,
          fixed: 'left',
        },
        {
          title: this.$t('商品.商品名称'),
          dataIndex: 'goodsName',
          width: 250,
          fixed: 'left',
        },
        /*{
          title: this.$t('商品.包装单位'),
          width: 60,
          dataIndex: 'unit',
        },*/
        {
          title: this.$t('商品.商品主图'),
          dataIndex: 'picture',
          width: 60,
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('商品.商品分类'),
          dataIndex: 'categoryId',
          width: 60,
          scopedSlots: {customRender: 'categoryId'},
        },
        {
          title: this.$t('商品.品牌'),
          dataIndex: 'brandId',
          width: 50,
          scopedSlots: {customRender: 'brandId'},
        },
        /*{
          title: this.$t('商品.售卖开始时间'),
          width: 150,
          dataIndex: 'saleStartTime',
        },
        {
          title: this.$t('商品.售卖结束时间'),
          width: 150,
          dataIndex: 'saleEndTime',
        },*/
        {
          title: this.$t('商品.市场价'),
          width: 50,
          dataIndex: 'marketPrice',
        },
        {
          title: this.$t('商品.商品价'),
          width: 50,
          dataIndex: 'price',
        },
        {
          title: this.$t('商品.商品状态'),
          dataIndex: 'status',
          width: 60,
          scopedSlots: {customRender: 'status'},
        },
        {
          title: this.$t('商品.创建时间'),
          dataIndex: 'createTime',
          width: 150,
          scopedSlots: {customRender: 'createTime'},
        },
      ],
      // 表单参数
      form: {
        id: null,
        userList: [],
        goodsList: [],
        userId: null,

        shopId: null,

        goodId: null,

        useOrderId: null,

        useItemId: null,

        money: null,

        unit: null,

        count: null,

        detailMessage: null,

        usstate: null,

        startTime: null,

        endTime: null,

        useTime: null,

        createTime: null,

        remark: null,

        state: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        money: [
          { required: true, message: this.$t('优惠券自动发放-用户.面额')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: this.$t('优惠券自动发放-用户.领用人')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        unit: [
          { required: true, message: this.$t('优惠券自动发放-用户.一个单位发放面额')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        count: [
          { required: true, message: this.$t('优惠券自动发放-用户.单位数量')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        usstate: [
          { required: true, message: this.$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('优惠券自动发放-用户.有效期开始时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: this.$t('优惠券自动发放-用户.有效期结束时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        state: [
          { required: true, message: this.$t('优惠券自动发放-用户.优惠券状态 1正常；2作废')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        goodsList: [],
        userList :[],
        shopId: null,
        goodId: null,
        useOrderId: null,
        useItemId: null,
        money: null,
        unit: null,
        count: null,
        detailMessage: null,
        usstate: null,
        startTime: null,
        endTime: null,
        useTime: null,
        createTime: null,
        remark: null,
        state: null
      }

    },

    //选择用户
    openUserSelect () {
      this.$refs.checkboxUserSelectForm.openUser();
    },
    indexUserSelect(records) {
      this.form.userId = records[0].id
      this.form.userList = records
      console.log('用户选择了',this.form.userList)

    },
    //选择商品
    openProdSelect() {
      console.log('打开商品选择框,单选模式')
      this.$refs.RadioGoodsSelectForm.openGoods(undefined, [this.form.goodId]);
    },
    indexGoodsModalSelect(records) {
      this.form.goodId = records[0].id
      this.form.goodsList = records
      console.log('商品选择了',this.form.goodsList)
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = "发放"
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCouponAuto({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateCouponAuto(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addCouponAuto(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
